module.exports = __webpack_public_path__ + "img/marker-2025.b0444654.svg";